module.exports = __webpack_public_path__ + "staticcomp/img/top.3d24ff4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/12/top.jpg
// module id = ydnj
// module chunks = 39